/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CsfSubcategoryRefDto } from './CsfSubcategoryRefDto';
import {
    CsfSubcategoryRefDtoFromJSON,
    CsfSubcategoryRefDtoFromJSONTyped,
    CsfSubcategoryRefDtoToJSON,
    CsfSubcategoryRefDtoToJSONTyped,
} from './CsfSubcategoryRefDto';
import type { CsfSubcategoryCoverageRowDto } from './CsfSubcategoryCoverageRowDto';
import {
    CsfSubcategoryCoverageRowDtoFromJSON,
    CsfSubcategoryCoverageRowDtoFromJSONTyped,
    CsfSubcategoryCoverageRowDtoToJSON,
    CsfSubcategoryCoverageRowDtoToJSONTyped,
} from './CsfSubcategoryCoverageRowDto';

/**
 * 
 * @export
 * @interface CsfFunctionCoverageDto
 */
export interface CsfFunctionCoverageDto {
    /**
     * 
     * @type {string}
     * @memberof CsfFunctionCoverageDto
     */
    frameworkSlug?: string;
    /**
     * 
     * @type {string}
     * @memberof CsfFunctionCoverageDto
     */
    functionCode?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CsfFunctionCoverageDto
     */
    catalogSupported?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CsfFunctionCoverageDto
     */
    totalSubcategories?: number;
    /**
     * 
     * @type {number}
     * @memberof CsfFunctionCoverageDto
     */
    coveredSubcategories?: number;
    /**
     * 
     * @type {number}
     * @memberof CsfFunctionCoverageDto
     */
    breadthRatio?: number;
    /**
     * 
     * @type {number}
     * @memberof CsfFunctionCoverageDto
     */
    depthCmmi?: number;
    /**
     * 
     * @type {number}
     * @memberof CsfFunctionCoverageDto
     */
    normalizedDepth?: number;
    /**
     * 
     * @type {number}
     * @memberof CsfFunctionCoverageDto
     */
    compositeScore?: number;
    /**
     * 
     * @type {number}
     * @memberof CsfFunctionCoverageDto
     */
    compositeCmmi?: number;
    /**
     * 
     * @type {number}
     * @memberof CsfFunctionCoverageDto
     */
    breadthWeight?: number;
    /**
     * 
     * @type {number}
     * @memberof CsfFunctionCoverageDto
     */
    depthWeight?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CsfFunctionCoverageDto
     */
    partialDepth?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CsfFunctionCoverageDto
     */
    mappedActiveInitiativeCount?: number;
    /**
     * 
     * @type {number}
     * @memberof CsfFunctionCoverageDto
     */
    initiativesContributingToDepthCount?: number;
    /**
     * 
     * @type {Array<CsfSubcategoryRefDto>}
     * @memberof CsfFunctionCoverageDto
     */
    uncoveredSubcategories?: Array<CsfSubcategoryRefDto>;
    /**
     * 
     * @type {Array<CsfSubcategoryCoverageRowDto>}
     * @memberof CsfFunctionCoverageDto
     */
    subcategoryRows?: Array<CsfSubcategoryCoverageRowDto>;
}

/**
 * Check if a given object implements the CsfFunctionCoverageDto interface.
 */
export function instanceOfCsfFunctionCoverageDto(value: object): value is CsfFunctionCoverageDto {
    return true;
}

export function CsfFunctionCoverageDtoFromJSON(json: any): CsfFunctionCoverageDto {
    return CsfFunctionCoverageDtoFromJSONTyped(json, false);
}

export function CsfFunctionCoverageDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CsfFunctionCoverageDto {
    if (json == null) {
        return json;
    }
    return {
        
        'frameworkSlug': json['frameworkSlug'] == null ? undefined : json['frameworkSlug'],
        'functionCode': json['functionCode'] == null ? undefined : json['functionCode'],
        'catalogSupported': json['catalogSupported'] == null ? undefined : json['catalogSupported'],
        'totalSubcategories': json['totalSubcategories'] == null ? undefined : json['totalSubcategories'],
        'coveredSubcategories': json['coveredSubcategories'] == null ? undefined : json['coveredSubcategories'],
        'breadthRatio': json['breadthRatio'] == null ? undefined : json['breadthRatio'],
        'depthCmmi': json['depthCmmi'] == null ? undefined : json['depthCmmi'],
        'normalizedDepth': json['normalizedDepth'] == null ? undefined : json['normalizedDepth'],
        'compositeScore': json['compositeScore'] == null ? undefined : json['compositeScore'],
        'compositeCmmi': json['compositeCmmi'] == null ? undefined : json['compositeCmmi'],
        'breadthWeight': json['breadthWeight'] == null ? undefined : json['breadthWeight'],
        'depthWeight': json['depthWeight'] == null ? undefined : json['depthWeight'],
        'partialDepth': json['partialDepth'] == null ? undefined : json['partialDepth'],
        'mappedActiveInitiativeCount': json['mappedActiveInitiativeCount'] == null ? undefined : json['mappedActiveInitiativeCount'],
        'initiativesContributingToDepthCount': json['initiativesContributingToDepthCount'] == null ? undefined : json['initiativesContributingToDepthCount'],
        'uncoveredSubcategories': json['uncoveredSubcategories'] == null ? undefined : ((json['uncoveredSubcategories'] as Array<any>).map(CsfSubcategoryRefDtoFromJSON)),
        'subcategoryRows': json['subcategoryRows'] == null ? undefined : ((json['subcategoryRows'] as Array<any>).map(CsfSubcategoryCoverageRowDtoFromJSON)),
    };
}

export function CsfFunctionCoverageDtoToJSON(json: any): CsfFunctionCoverageDto {
    return CsfFunctionCoverageDtoToJSONTyped(json, false);
}

export function CsfFunctionCoverageDtoToJSONTyped(value?: CsfFunctionCoverageDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'frameworkSlug': value['frameworkSlug'],
        'functionCode': value['functionCode'],
        'catalogSupported': value['catalogSupported'],
        'totalSubcategories': value['totalSubcategories'],
        'coveredSubcategories': value['coveredSubcategories'],
        'breadthRatio': value['breadthRatio'],
        'depthCmmi': value['depthCmmi'],
        'normalizedDepth': value['normalizedDepth'],
        'compositeScore': value['compositeScore'],
        'compositeCmmi': value['compositeCmmi'],
        'breadthWeight': value['breadthWeight'],
        'depthWeight': value['depthWeight'],
        'partialDepth': value['partialDepth'],
        'mappedActiveInitiativeCount': value['mappedActiveInitiativeCount'],
        'initiativesContributingToDepthCount': value['initiativesContributingToDepthCount'],
        'uncoveredSubcategories': value['uncoveredSubcategories'] == null ? undefined : ((value['uncoveredSubcategories'] as Array<any>).map(CsfSubcategoryRefDtoToJSON)),
        'subcategoryRows': value['subcategoryRows'] == null ? undefined : ((value['subcategoryRows'] as Array<any>).map(CsfSubcategoryCoverageRowDtoToJSON)),
    };
}

